export enum ApiResponseCode {
  SUCCESS = 'SUCCESS',
  // base-error.ts enum 'ErrorStatusCode' in API below:
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  NOT_FOUND = 'NOT_FOUND',
  EMAIL_IN_USE = 'EMAIL_IN_USE',
  INVALID = 'INVALID',
}
